import React from 'react';
import ReactApexChart from 'react-apexcharts';

interface GaugeChartProps {
  value: number;
  color?: string;
  percent?: boolean;
}

const GaugeChart: React.FC<GaugeChartProps> = ({ value, color = '#1976d2', percent = true }) => {
  const options = {
    chart: {
      type: 'radialBar' as const,
      offsetY: 0,
    },
    plotOptions: {
      radialBar: {
        startAngle: -135,
        endAngle: 135,
        hollow: {
          margin: 0,
          size: '50%',
        },
        track: {
          background: '#e7e7e7',
          strokeWidth: '80%',
          margin: 5,
        },
        dataLabels: {
          name: {
            show: false
          },
          value: {
            show: true,
            fontSize: '24px',
            color: color,
            formatter: function (val: number) {
              return val + `${percent ? '%' : ''}`;	
            },
            offsetY: 0
          },
        },
      },
    },
    fill: {
      colors: [color],
    },
    stroke: {
      lineCap: 'round' as const,
    },
    labels: ['']
  };

  const series = [value];

  return (
    <ReactApexChart
      options={options}
      series={series}
      type="radialBar"
      height={250}
    />
  );
};

export default GaugeChart;